/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';

import { BreakPoint, Color, FontSize } from '../../asset/styles';
import { Button } from '../../../common/primitive';

const StyledSpan = styled.span`
  display: inline-block;
  width: 100%;

  button {
    background-color: ${Color.white};
    border: solid 1px ${Color.border.darkGray};
    border-radius: 4px;
    color: ${Color.text.gray};
    cursor: pointer;
    font-size: ${FontSize.medium};
    padding: 7px;
    width: 100%;
    outline: none;

    &.primary {
      background-color: ${Color.red};
      border-color: ${Color.red};
      color: ${Color.text.white};
    }

    @media (min-width: ${BreakPoint.desktop}) {
      font-size: ${FontSize.desktop.medium};
    }
  }
`;

/**
 * yes / no button を作成します - {@link Permission}
 * @param {boolean} [primary=false] true: red 表示になります
 * @param {*} props React.props {@link Button} へ付与します
 * @return {*} yes / no button を返します
 * @constructor
 */
const Primary = ({ primary = false, ...props }) => (
  <StyledSpan className={`Primary ${primary ? 'primary' : 'secondary'}`}>
    <Button className={primary ? 'primary' : 'secondary'} {...props} />
  </StyledSpan>
);

Primary.propTypes = {
  primary: PropTypes.bool.isRequired,
};

export default Primary;



// WEBPACK FOOTER //
// ./src/phase2/survey/component/button/Primary.js